import React from 'react';
import { Box, Typography } from '@mui/material';
import { FiSearch } from 'react-icons/fi';

export default function SemResultados() {
  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3, width: '100%', maxWidth: 400 }}>
        <Box
          sx={{
            p: { xs: 2.5, md: 3 },
            borderRadius: 2.5,
            border: '1px solid',
            borderColor: 'grey.200',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            bgcolor: '#fff',
            textAlign: 'center',
          }}
        >
          <FiSearch size={48} color="#999" style={{ marginBottom: 12 }} />
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a1a2e', mb: 0.5 }}>
            Nenhum resultado encontrado
          </Typography>
          <Typography variant="body2" sx={{ color: '#999' }}>
            Tente buscar com outros termos ou use os filtros.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
